<template>
  <div
    class="PaymentMethod"
    :class="{ 'isLoading': isPreviewing }"
    data-scroll="paymentMethod"
  >
    <transition name="fade" mode="out-in" v-if="isPreviewing">
      <app-loading
        :is-loading="isPreviewing"
        :size="30"
      />
    </transition>

    <div class="PaymentMethod_container" v-else>
      <template v-if="!disablePayment">
        <div class="PaymentMethod_header flex-between" v-if="hasPayment || paymentRequirement !== 'None'">
          <h2 class="title">
            {{ $t('checkout.payment.title', 'Payment method') }}
          </h2>
          <checkout-nav :step-numer="3" />
        </div>

        <div class="PaymentMethod_body">
          <div class="PaymentInformation_wrapper" v-if="hasPayment">
            <transition name="fade" mode="out-in" v-if="isLoading">
              <app-loading
                :is-loading="isLoading"
                :size="30"
              />
            </transition>

            <template v-else>
              <payment-information
                v-if="hasPaymentProfile"
                :checkout-step="true"
                :tax-amount="firstTermTaxAmount"
                :is-display-tax="isDisplayTax"
              />

              <app-info-field
                v-else
                class="paymentInfo-tips"
                :text="$t('checkout.paymentInformation.processing', 'Your first payment information is being processed, please create a new order later')"
              />
            </template>
          </div>

          <template v-else-if="paymentRequirement !== 'None'">
            <p v-if="paymentRequirement === 'Authorization'" class="payment-tips with-border">
              {{ $t('checkout.paymentMethod.verification.tips', 'Although your subscription is free, we need your payment information for future payment. A verification payment of 0.10 will be made and refunded to verify your method.') }}
            </p>

            <div class="PaymentMethod-component">
              <app-loading
                class="translucence"
                v-if="taskIsActive"
                component="looping-rhombuses-spinner"
                :animation-duration="2000"
                :size="30"
              />

              <app-accordion-list
                :expand-first-item="defaultExpend"
                :record-accordion-id="true"
                @accordion-change="setExpandAccordionId($event)"
                ref="PaymentMethod-component-list"
              >
              <app-accordion

                  v-if="this.paymentMethodsCreditCardtemp.length && currentCountryCode === 'GB'"
                  id="payment-type-scheme"
                >
                  <template slot="title" >

                    <span class="payment-method_radio"></span>
                    {{ $t('common.paymentMethod.type.scheme', 'Credit Card') }}

                  </template>

                  <template slot="right-icon">
                    <span class="payment-method_icon">
                      <img
                        v-for="paymentMethod in paymentMethodsCreditCardtemp"
                        :src="paymentMethod.logoUrl"
                        :alt="paymentMethod.name"
                        :key="paymentMethod.name">
                    </span>

                  </template>

                  <template slot="body">
                    <app-select
                      class="select-creditCard"
                      :placeholder="$t('checkout.payment.creditCard.placeholder.selectdCard', 'Select your card')"
                      v-model="selectedpaymentMethodsCreditCardtemp"
                      :options="paymentMethodsCreditCardtemp"
                      :searchable="false"
                      :allow-empty="false"
                      :show-labels="false"
                      label="name"
                      track-by="code"
                      open-direction="bottom"
                      @select="selectCreditCard"
                    >
                      <template slot="singleLabel" slot-scope="props">
                        <span class="option__title">{{ props.option.name }}</span>
                        <img class="option__image" :src="props.option.logoUrl" :alt="props.option.name">
                      </template>
                      <template slot="option" slot-scope="props">
                        <span class="option__title">{{ props.option.name }}</span>
                        <img class="option__image" :src="props.option.logoUrl" :alt="props.option.name">
                      </template>
                    </app-select>

                    <div class="payment-description">
                      <h4 class="amount-total">
                        <strong>{{ $t('checkout.payment.summary.label.amount', 'Amount') }} ({{ detectedCulture.currency.code }}):</strong>
                        {{ firstTermTotalAmount | formatCurrency(true) }}
                      </h4>
                      <div class=amount-description>
                        <h5>{{ $t('checkout.payment.summary.label.description', 'description') }}</h5>
                        <p class="tips">
                          {{
                            $t('checkout.payment.summary.description', {
                              totalAmount: $options.filters.formatCurrency(firstTermTotalAmount, true),
                              taxAmount: $options.filters.formatCurrency(firstTermTaxAmount, true)
                            })
                          }}
                        </p>
                      </div>
                    </div>
                  </template>
                </app-accordion>
                <app-accordion
                  v-if="paymentMethodsCreditCard.length && currentCountryCode != 'GB'"
                  id="payment-type-scheme"
                >
                  <template slot="title">
                    <span class="payment-method_radio"></span>
                    {{ $t('common.paymentMethod.type.scheme', 'Credit Card') }}
                  </template>

                  <template slot="right-icon">
                    <span class="payment-method_icon">
                      <img
                        v-for="paymentMethod in paymentMethodsCreditCard"
                        :src="paymentMethod.logoUrl"
                        :alt="paymentMethod.name"
                        :key="paymentMethod.name">
                    </span>
                  </template>

                  <template slot="body">
                    <app-select
                      class="select-creditCard"
                      :placeholder="$t('checkout.payment.creditCard.placeholder.selectdCard', 'Select your card')"
                      v-model="selectedPaymentMethodCreditCard"
                      :options="paymentMethodsCreditCard"
                      :searchable="false"
                      :allow-empty="false"
                      :show-labels="false"
                      label="name"
                      track-by="code"
                      open-direction="bottom"
                      @select="selectCreditCard"
                    >
                      <template slot="singleLabel" slot-scope="props">
                        <span class="option__title">{{ props.option.name }}</span>
                        <img class="option__image" :src="props.option.logoUrl" :alt="props.option.name">
                      </template>
                      <template slot="option" slot-scope="props">
                        <span class="option__title">{{ props.option.name }}</span>
                        <img class="option__image" :src="props.option.logoUrl" :alt="props.option.name">
                      </template>
                    </app-select>

                    <div class="payment-description">
                      <h4 class="amount-total">
                        <strong>{{ $t('checkout.payment.summary.label.amount', 'Amount') }} ({{ detectedCulture.currency.code }}):</strong>
                        {{ firstTermTotalAmount | formatCurrency(true) }}
                      </h4>
                      <div class=amount-description>
                        <h5>{{ $t('checkout.payment.summary.label.description', 'description') }}</h5>
                        <p class="tips">
                          {{
                            $t('checkout.payment.summary.description', {
                              totalAmount: $options.filters.formatCurrency(firstTermTotalAmount, true),
                              taxAmount: $options.filters.formatCurrency(firstTermTaxAmount, true)
                            })
                          }}
                        </p>
                      </div>
                    </div>
                  </template>
                </app-accordion>

                <app-accordion
                  v-for="paymentMethod in paymentMethodsNotCreditCard"
                  :key="paymentMethod.name"
                  :id="`payment-type-${paymentMethod.name}`"
                >
                  <template slot="title">
                    <span class="payment-method_radio"></span>
                    {{ $t(`common.paymentMethod.type.${paymentMethod.name}`, paymentMethod.name) }}
                  </template>

                  <template slot="right-icon">
                    <span class="payment-method_icon">
                      <img
                        :src="paymentMethod.logoUrl"
                        :alt="paymentMethod.name"
                        :class="{'payment-method_paypal':paymentMethod.name==='Paypal'}">
                    </span>
                  </template>

                  <template slot="body">
                    <div class="payment-description">
                      <h4 class="amount-total">
                        <strong>{{ $t('checkout.payment.summary.label.amount', 'Amount') }} ({{ detectedCulture.currency.code }}):</strong> {{ firstTermTotalAmount | formatCurrency(true) }}
                      </h4>
                      <div class=amount-description>
                        <h5>{{ $t('checkout.payment.summary.label.description', 'description') }}</h5>
                        <p class="tips">
                          {{
                            $t('checkout.payment.summary.description', {
                              totalAmount: $options.filters.formatCurrency(firstTermTotalAmount, true),
                              taxAmount: $options.filters.formatCurrency(firstTermTaxAmount, true)
                            })
                          }}
                        </p>
                      </div>
                    </div>
                  </template>
                </app-accordion>
              </app-accordion-list>
            </div>
            <!-- <div class="Paypal-deact-msg" v-if="currentCountryCode === 'DE' || currentCountryCode === 'GB'">
              <div class="paypal-inmsg">
                <h3 class="Accordion_title"><span class="payment-method_radio"></span>
                  Paypal
                </h3>
                <div id="content">
                  {{ $t('checkout.paymentMethod.verification.sbe',  '"paypal is temporarily not avilable"') }}
                </div>
              </div>
              <div class="payment-method_icon">
                <img src="https://images.prismic.io/philips-subscription-prod/e80f9fc0-d9f2-4bc3-815f-33a0566129cc_Paypal.png?auto=compress,format" alt="Paypal" height="15rem" vertical-align: right>
              </div>
            </div> -->
          </template>
        </div>
      </template>

      <div class="PaymentMethod_footer">
        <div class="terms">
          <p>
            <template v-if="sbeCompliance === 'False' || (currentCountryCode === 'DE' && sbeCompliance === 'NA') || (currentCountryCode === 'NL' && sbeCompliance === 'NA') || (currentCountryCode === 'GB' && sbeCompliance === 'NA')
          ">
            {{ $t('checkout.Payment.terms.text2', 'By clicking "Confirm", I confirm that I have read and understood the') }}
            <!-- <a
           class="link"
           target="_blank"
          :href="$t('checkout.payment.terms.text.sbe', '##')">{{ $t('checkout.payment.terms.text.sbe.link', 'What does this mean?') }}
           </a> -->
            </template>
            <template v-if="disablePayment">
              {{ $t('checkout.noPayment.terms.text', 'By clicking "Confirm", I confirm that I have read and understood the') }}
            </template>
            <template v-if="(!disablePayment && currentCountryCode === 'DE' && sbeCompliance === 'True') || (!disablePayment && currentCountryCode === 'NL' && sbeCompliance === 'True') || (!disablePayment && currentCountryCode === 'GB' && sbeCompliance === 'True') || (!disablePayment && currentCountryCode === 'US' && sbeCompliance === 'True') || (!disablePayment && currentCountryCode === 'US' && sbeCompliance === 'NA') || (!disablePayment && currentCountryCode === 'CA' && sbeCompliance === 'True') || (!disablePayment && currentCountryCode === 'CA' && sbeCompliance === 'NA') || (!disablePayment && currentCountryCode === 'BE' && sbeCompliance === 'NA') || (!disablePayment && currentCountryCode === 'BE' && sbeCompliance === 'True') || (!disablePayment && currentCountryCode === 'ES' && sbeCompliance === 'NA') || (!disablePayment && currentCountryCode === 'ES' && sbeCompliance === 'True') || (!disablePayment && currentCountryCode === 'IT' && sbeCompliance === 'NA') || (!disablePayment && currentCountryCode === 'IT' && sbeCompliance === 'True') || (!disablePayment && currentCountryCode === 'RO' && sbeCompliance === 'True') || (!disablePayment && currentCountryCode === 'RO' && sbeCompliance === 'NA') || (!disablePayment && currentCountryCode === 'CZ' && sbeCompliance === 'True') || (!disablePayment && currentCountryCode === 'CZ' && sbeCompliance === 'NA')">
              {{ $t('checkout.payment.terms.text', 'By clicking "Confirm and Pay", I confirm that I have read and understood the') }}
            </template>
            <template v-for="(item, index) in bundlesTerms">
            <template
              v-if="(currentCountryCode === 'DE' && sbeCompliance === 'True') || (currentCountryCode === 'NL' && sbeCompliance === 'True') || (currentCountryCode === 'GB' && sbeCompliance === 'True') || (currentCountryCode === 'US' && sbeCompliance === 'True') || (currentCountryCode === 'US' && sbeCompliance === 'NA') || (currentCountryCode === 'CA' && sbeCompliance === 'True') || (currentCountryCode === 'CA' && sbeCompliance === 'NA') || (currentCountryCode === 'BE' && sbeCompliance === 'True') || (currentCountryCode === 'BE' && sbeCompliance === 'NA') || (currentCountryCode === 'BE' && sbeCompliance === 'NA') || (currentCountryCode === 'BE' && sbeCompliance === 'True') || (currentCountryCode === 'ES' && sbeCompliance === 'NA') || (currentCountryCode === 'ES' && sbeCompliance === 'True') || (currentCountryCode === 'IT' && sbeCompliance === 'NA') || (currentCountryCode === 'IT' && sbeCompliance === 'True') || (currentCountryCode === 'SE' && sbeCompliance === 'True') || (currentCountryCode === 'SE' && sbeCompliance === 'NA') || (currentCountryCode === 'FR' && sbeCompliance === 'True') || (currentCountryCode === 'FR' && sbeCompliance === 'NA') || (currentCountryCode === 'AT' && sbeCompliance === 'True') || (currentCountryCode === 'AT' && sbeCompliance === 'NA') || (currentCountryCode === 'RO' && sbeCompliance === 'True') || (currentCountryCode === 'RO' && sbeCompliance === 'NA') || (currentCountryCode === 'CZ' && sbeCompliance === 'True') || (currentCountryCode === 'CZ' && sbeCompliance === 'NA')">
              <a
                :key="item.bundleName"
                href="##"
                class="link"
                @click.prevent="$bus.$emit('open-modal', `${item.bundleName}`)"
              >
                {{ item.bundleName }}
              </a>
              <span v-if="bundlesTerms.length > 1 && index < bundlesTerms.length - 1 " :key="index">, </span>
            </template>
            </template>
            <template v-if="$t('checkout.noPayment.terms.subText') && disablePayment">
              {{ $t('checkout.noPayment.terms.subText') }}
            </template>
            <template v-if="$t('checkout.payment.terms.subText') && (currentCountryCode === 'DE' && sbeCompliance === 'True') || (currentCountryCode === 'NL' && sbeCompliance === 'True') || (currentCountryCode === 'GB' && sbeCompliance === 'True') || (currentCountryCode === 'US' && sbeCompliance === 'True') || (currentCountryCode === 'US' && sbeCompliance === 'NA') || (currentCountryCode === 'CA' && sbeCompliance === 'True') || (currentCountryCode === 'CA' && sbeCompliance === 'NA') || (currentCountryCode === 'BE' && sbeCompliance === 'NA') || (currentCountryCode === 'BE' && sbeCompliance === 'NA') || (currentCountryCode === 'BE' && sbeCompliance === 'True') || (currentCountryCode === 'ES' && sbeCompliance === 'NA') || (currentCountryCode === 'ES' && sbeCompliance === 'True') || (currentCountryCode === 'IT' && sbeCompliance === 'NA') || (currentCountryCode === 'IT' && sbeCompliance === 'True') || (currentCountryCode === 'SE' && sbeCompliance === 'True') || (currentCountryCode === 'SE' && sbeCompliance === 'NA') || (currentCountryCode === 'FR' && sbeCompliance === 'True') || (currentCountryCode === 'FR' && sbeCompliance === 'NA') || (currentCountryCode === 'AT' && sbeCompliance === 'True') || (currentCountryCode === 'AT' && sbeCompliance === 'NA') || (currentCountryCode === 'RO' && sbeCompliance === 'True') || (currentCountryCode === 'RO' && sbeCompliance === 'NA') || (currentCountryCode === 'CZ' && sbeCompliance === 'True') || (currentCountryCode === 'CZ' && sbeCompliance === 'NA')">
              {{ $t('checkout.payment.terms.subText') }}
            </template>
          </p>
        </div>

        <template v-for="item in bundlesTerms">
          <app-modal :name="item.bundleName" :key="item.bundleName">
            <div class="v--modal-content" v-html="item.termsText"></div>
          </app-modal>
        </template>

        <app-button
          type="submit"
          @click.prevent="submitOrderTask.run()"
          :disabled="taskIsActive ||
            !(selectedPaymentMethod ||
              (!selectedPaymentMethod &&
              (hasPayment || paymentRequirement === 'None')) ||
            (!selectedPaymentMethod && disablePayment)) ||
            (hasPayment && !hasPaymentProfile) || isFailPayment || sbeCompliance === 'False' || (currentCountryCode === 'DE' && sbeCompliance === 'NA') || (currentCountryCode === 'NL' && sbeCompliance === 'NA') || (currentCountryCode === 'GB' && sbeCompliance === 'NA')
            || bundleflag"
          data-name="checkoutPaymentMethod-submitButton"
          class="orange-button"
        >
          <template v-if="disablePayment">
            {{ $t('checkout.noPayment.button.confirmOrder', 'Confirm') }}
          </template>

          <template v-else>
            {{ $t('checkout.payment.button.confirmOrder', 'Confirm order') }}
          </template>
        </app-button>

         <div class="OFSmsg" v-show="bundleflag">   
          {{ $t('checkout.paymentMethod.bundleoutofstockmessage', 'Product is currently out of stock.') }} 
         </div>

        <app-modal name="paymentFailedNotification" width="500" class="paymentFailedNotification">
          <div class="v--modal-content">
            <h3 class="modal-title">
            </h3>
            <div class="modal-content">
              <p>
                {{ $t('checkout.paymentFailedNotification.tip', 'Sorry, it seems that we are not able to process your order with your current payment method and details. Please try again, or change your payment method and/or details.') }}
              </p>
              <div class="modal-button-wrapper">
                <app-button
                  type="submit"
                  @click.prevent="openPaymentFailedPopUp"
                >
                  {{ $t('checkout.paymentFailedNotification.button.confirm', 'Change payment method/details') }}
                </app-button>
                <app-button
                  type="submit"
                  @click.prevent="closePaymentFailedPopUp"
                >
                  {{ $t('checkout.paymentFailedNotification.button.close', 'Cancel') }}
                </app-button>
              </div>
            </div>
          </div>
        </app-modal>

        <template>
          <div>
          <br>
         <div id="payment-page">
         <div class="container">
         <div class="payment-container">
         <div id="dropin-container"></div>
         </div>
         </div>
         </div>
         </div>
        </template>


        <template v-if="!hasPayment && paymentRequirement !== 'None'">
          <p class="flex-center secureType">
            <!-- {{ $t('checkout.payment.secureType', 'You will be redirected to a secure checkout page.') }} -->
          </p>

          <div ref="paymentForm" v-html="paymentForm" v-show="false"></div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import CheckoutNav from 'components/CheckoutNav'
  import { extractErrorMessage } from '@/utilities/common'
  import { mapState, mapGetters } from 'vuex'
  import Vue from 'vue'
  import PaymentMixin from 'mixins/payment'
  import { detectedCulture } from '@/utilities/common/culture'
  import { flattenDepth, uniqWith, isEqual } from 'lodash'
  import AdyenCheckout from '@adyen/adyen-web';
  import '@adyen/adyen-web/dist/adyen.css'; 

  export default {
    name: 'checkout-payment-method',

    components: {
      CheckoutNav
    },

    mixins: [PaymentMixin],

    props: {
      bundles: {
        type: Array,
        required: true
      },
      previewBundle: {
        type: Array,
        required: true
      },
      bundleName: {
        type: Array,
        default: null
      } 
    },

    data () {
      return {
        detectedCulture: detectedCulture,
        selectedPaymentMethod: null,
        selectedPaymentMethodCreditCard: null,
        defaultExpend: false,
        cancelPaymentUrl: window.location.href,
        isFailPayment: false,
        currentCountryCode: detectedCulture.countryCode,
        detectedCulture: detectedCulture
      }
    },

    computed: {
      ...mapState('culture',  ['isDisplayTax', 'paymentMethods','paymentMethodCode']),

      ...mapGetters('culture', ['paymentMethodsCreditCard', 'paymentMethodsCreditCardtemp', 'paymentMethodsNotCreditCard']),

      ...mapState('checkout', {
        bundlesTerms: state => state.bundlesInfor.termsTexts,
        isPreviewing: state => state.subscription.isPreviewing,
        firstTermTaxAmount: state => state.subscription.firstTermTaxAmount,
        firstTermTotalAmount: state => state.subscription.firstTermTotalAmount,
        cartDetails: state => state.cartDetails,
        disablePayment: state => state.cartDetails.disablePayment,
        paymentRequirement: state => state.subscription.paymentRequirement
      }),

      ...mapGetters('checkout', ['bundlePhoneNumberisRequired']),

      ...mapState('account', {
        hasPayment: state => state.profile.personalDetail.hasPayment,
        ableToSubscribe: state => state.profile.personalDetail.ableToSubscribe,
        initialPhoneNumber: state => state.profile.personalDetail.initialPhoneNumber,
        sbeCompliance: state => state.profile.personalDetail.sbeCompliance
      }),

      ...mapGetters('account', ['paymentActivity']),

      bundlesName () {
        return (this.$route.query.bundles && this.$route.query.bundles.split(',')) || null
      },

      bundleflag (){ 
        if(this.cartDetails.groups[0].items[0].bundleAvailable === 'false'){
          return true 
        } 
      },

      couponCodes () {
        const codes = []
        JSON.parse(JSON.stringify(flattenDepth(this.previewBundle), 1)).map(bundle => {
          bundle.promotions.forEach(({ code }) => {
            codes.push(code)
          })
        })
        return uniqWith(codes, isEqual)
      }
    },

    methods: {
      setExpandAccordionId (expandAccordionId) {
        if (expandAccordionId) {
          this.trackConversion({ name: 'interaction', description: 'button:payment_method' })
          const paymentMethodType = expandAccordionId.substring(expandAccordionId.lastIndexOf('-') + 1)
          if (paymentMethodType === 'scheme') {
            this.selectedPaymentMethod = this.selectedPaymentMethodCreditCard
          } else {
            this.selectedPaymentMethod = this.paymentMethods.find(item => item.name === paymentMethodType)
          }
        } else {
          this.selectedPaymentMethod = null
        }
      },

      selectCreditCard (option) {
        this.trackConversion({ name: 'interaction', description: 'button:payment_method' })
        this.selectedPaymentMethod = option
      },

      openPaymentFailedPopUp () {
        this.$router.replace({
          name: 'payment-details'
        })
        this.$bus.$emit('close-modal', 'paymentFailedNotification')
        this.isFailPayment = true
      },

      closePaymentFailedPopUp () {
        this.$bus.$emit('close-modal', 'paymentFailedNotification')
        this.isFailPayment = true
      }
    },

    tasks (t) {
      return {
        submitOrderTask: t(async function () { 
		    if (this.ableToSubscribe) {
            if (this.paymentActivity.hasInvalidRecurringPaymentDetail) {
              this.isFailPayment = true
              this.$bus.$emit('open-modal', 'paymentFailedNotification')
            } else {
              const profile = await Vue.api.account.fetchProfile()
               if(!(profile.phoneNumber && profile.phoneNumber.length > 0) && (this.bundlePhoneNumberisRequired == true)){
                this.$notify({
                  type: 'error',
                  title: this.$t('popuptips.product.phoneNumber.isRequired', 'You need to update the phone number when you subscription this product')
                })
                this.$bus.$emit('scroll-next-step', '[data-scroll="personalDetail"]')
              } else {
                this.taskIsActive = true

                if (!this.hasPayment && this.selectedPaymentMethod) {
                  this.trackConversion({
                    name: 'interaction', description: `payment_method:${this.selectedPaymentMethod.name}:confirm_order`
                  })
                }

                const paymentCallBack = await this.$store.dispatch('checkout/submitOrder', {
                  paymentMethodCode: this.selectedPaymentMethod && this.selectedPaymentMethod.code,
                  bundles: this.previewBundle,
                  cancelPaymentUrl: this.cancelPaymentUrl
                })
                const paymentForm = paymentCallBack.htmlForm
                let packingInfo = {
                  ctn: paymentCallBack.packingInfo.ctn,
                  qty: paymentCallBack.packingInfo.qty,
                  totalPrice: paymentCallBack.packingInfo.totalPrice,
                  orderNumber: paymentCallBack.orderNumber,
                  bundlesName: this.bundleName,
                  currencyCode: this.detectedCulture.currency.code,
                  couponCode: JSON.parse(JSON.stringify(flattenDepth(this.couponCodes), 1))
                }
                window.sessionStorage.setItem('packingInfo', JSON.stringify(packingInfo))
                if( (paymentForm && this.selectedPaymentMethod.provider === 'Adyen' && this.selectedPaymentMethod.name !== 'Sofort')) {
         
  
         await Vue.api.payment.adyenpayment(this.selectedPaymentMethod.provider, this.firstTermTotalAmount, this.sbeCompliance, paymentCallBack.orderNumber, this.selectedPaymentMethod.code).then(data => {
        console.log(data)
         localStorage.setItem('sessionID', data.id);
        localStorage.setItem('sessiondata', data.session);
        localStorage.setItem('Client', data.clientKey);
        localStorage.setItem('Env', data.environment);
        
      }).catch((error) => {
        this.$notify({
          type: 'error',
          title: extractErrorMessage(error)
        })
      })

      let brandcode = this.selectedPaymentMethod.code.split('.')[1]
      const cardConfiguration = {
      hasHolderName: true,
      holderNameRequired: true,
   
       brands:[brandcode],
   
     };

       const configuration = {
       environment: window.localStorage.getItem('Env'),
       clientKey: window.localStorage.getItem('Client'),
       showPayButton: true,
    session: {
    id: window.localStorage.getItem('sessionID'), 
    sessionData: window.localStorage.getItem('sessiondata'),
  },
  onPaymentCompleted: (result, component) => {

   if(result.resultCode === 'Authorised'){
          window.location.href = `${window.location.origin}/${this.$router.options.base}/subscription-successful`
    }
      console.info(result, component);
  },
  onError: (error, component) => {
      console.error(error.name, error.message, error.stack, component);
  },
 
  paymentMethodsConfiguration: {
   card: cardConfiguration
  }
};
     // Create an instance of AdyenCheckout using the configuration object.
       const checkout = await AdyenCheckout(configuration);
        // Create an instance of Drop-in and mount it to the container you created.
      const dropinComponent = checkout.create('dropin').mount('#dropin-container');
          //  window.location.href = `${window.location.origin}/${this.$router.options.base}/AdyenPayments`
         
             } else if (paymentForm) {
                  this.paymentForm = paymentForm
                } else {
                  window.location.href = `${window.location.origin}/${this.$router.options.base}/subscription-successful`
                }
              }
            }
			
          } else if (!this.ableToSubscribe) {
            this.$notify({
              type: 'error',
              title: this.$t('popuptips.user.disableToSubscribe', 'Sorry, that isn’t possible yet! We need a due payment/return from you first.')
            })
          }
        }).onError(function (task) {
          this.taskIsActive = false
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
          if (task.error.data && task.error.data.code === 'error.message.promotionIsInvalid') {
            this.$bus.$emit('scroll-next-step', '[data-scroll="shoppingCart"]')
          } else if (task.error.data && task.error.data.code === 'error.message.orderPreviewFailed') {
            this.$bus.$emit('scroll-next-step', '[data-scroll="address"]')
          } else if (Array.isArray(task.error.data)) {
            this.$bus.$emit('scroll-next-step', '[data-scroll="personalDetail"]')
            this.$notify({
              type: 'error',
              title: this.$t('popuptips.account.pre-filled.information.fields.invalid', 'Some information you filled in are invalid, please click the edit button to check and modify it')
            })
          }
        }).flow('drop')
      }
    },

    created () {
      if ((this.paymentMethodsNotCreditCard !== 0 && this.paymentMethodsCreditCard.length === 0) || (this.paymentMethodsNotCreditCard.length === 0 && this.paymentMethodsCreditCard.length !== 0)) {
        this.defaultExpend = true
      }
      if (this.hasPayment) {
        this.fetchMyPaymentMethod()
      }
    }
  }
</script>

<style lang="scss">
  .adyen-checkout__button--pay {
    background-color: #0abf53;
    font-weight: 900;
    border-radius: 0;
  }
  // #payment-type-Paypal {
  //   display: none;
  // }

  // .Paypal-deact-msg {
  //   padding: 15px;
  //   border-radius: 8px;
  //   border: .01rem solid #c4c4c4;
  //   display: flex;
  //   width: 100%;

  //   .payment-method_icon {
  //     margin-left: auto;
  //     justify-content: flex-end;
  //   }

  //   .payment-method_radio {
  //     display: flex;
  //     height: .24rem;
  //     width: .24rem;
  //     border-radius: 50%;
  //     border: .01rem solid #c4c4c4;
  //     margin-right: .14rem;
  //   }

  //   .Accordion_title {
  //     display: inline-flex;
  //     align-items: center;
  //     font-size: 0.16rem;
  //     font-weight: 400;
  //   }

  //   #content {
  //     padding-left: 200px;
  //   }
  // }
  .OFSmsg {
    color: #e60000;
    padding: 5px;
    text-align: center;
    margin-top: 10px;
    font-weight: bold;
  }

  .left-align {
    text-align: left;
  }

  .PaymentMethod {
    position: relative;

    &.isLoading {
      min-height: .8rem;
      margin-top: .2rem;
    }

    .AppLoadingMask {
      background: #f2f2f2;
    }

    &_header {
      padding: .175rem .1rem;
    }

    &_body {
      .payment-tips {
        font-weight: 500;
        margin-bottom: .15rem;

        &.with-border {
          border: 1px solid #1574a4;
          border-radius: .08rem;
          padding: .16rem;
        }
      }

      .PaymentInformation {
        &_wrapper {
          position: relative;
          min-height: .46rem;
        }
      }
    }

    &_footer {
      margin-top: .25rem;

      .Form_group-choice {
        margin-bottom: .25rem;
        padding: 0 .17rem;

        .Form_label {
          font-size: .14rem;
          color: #4b4b4b;
        }
      }

      .secureType {
        margin: .2rem 0;
      }

      .terms {
        margin-bottom: .25rem;

        p {
          display: inline-block;
        }

        .link {
          font-size: .14rem;
        }
      }

      .orange-button {
        background-color: $orange-button;
      }
    }

    &-component {
      position: relative;

      &.isLoading {
        min-height: 1rem;
        margin-bottom: .18rem;
      }

      .Accordion {
        border: .01rem solid #c4c4c4;
        background: #fff;
        border-radius: .08rem;
        margin-bottom: .18rem;
        transition: all .3s ease-in-out;

        &:last-child {
          margin-bottom: .18rem;
        }

        &_header {
          color: #4b4b4b;
          background: transparent;
          padding: 0 .16rem;
          height: .56rem;
        }

        &_title {
          display: inline-flex;
          align-items: center;
          font-size: .16rem;
          font-weight: 400;
        }

        &_body {
          padding: .05rem .2rem .16rem;

          .directEbanking-tips {
            font-size: .16rem;
            font-weight: 700;
          }
        }

        .payment-method_radio {
          display: flex;
          align-items: center;
          justify-content: center;
          height: .24rem;
          width: .24rem;
          background: transparent;
          border: .01rem solid #c4c4c4;
          border-radius: 50%;
          margin-right: .14rem;
        }

        .payment-method_icon {
          flex-shrink: 0;

          img {
            filter: grayscale(1);
            height: .3rem;
            width: auto;

            & + img {
              margin-left: .12rem;
            }
          }

          .payment-method_paypal {
            width: .7rem;
            height: auto;
          }
        }

        &.expand {
          border: 1px solid #1574a4;
          margin-bottom: .18rem;

          .Accordion_title {
            font-weight: 700;
            color: #1574a4;
          }

          .payment-method_radio {
            border-color: #1f78a7;

            &::after {
              content: "";
              width: .08rem;
              height: .08rem;
              display: block;
              background: #1f78a7;
              border-radius: 50%;
            }
          }

          .payment-method_icon {
            img {
              filter: grayscale(0);
            }
          }
        }
      }

      .payment-description {
        color: #333;

        .amount-total {
          font-weight: 400;
          font-size: .16rem;
          line-height: .19rem;
          margin-bottom: .05rem;

          strong {
            font-weight: 700;
          }
        }

        .amount-description {
          font-size: .14rem;

          h5 {
            font-size: .14rem;
            font-weight: 700;
            color: #333;
            line-height: .22rem;
          }
        }
      }

      .select-creditCard {
        margin-bottom: .2rem;
      }

      .multiselect {
        &__single,
        &__option {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        &__placeholder {
          line-height: .25rem;
        }

        .option__image {
          height: .25rem;
          width: auto;
        }

        &__option--highlight::after,
        &__option--selected::after {
          display: none;
        }
      }
    }

    .paymentFailedNotification.v--modal-overlay {
      .v--modal-box {
        .v--modal-container {
          .modal-content {
            min-height: 2rem;

            p {
              margin: .1rem .1rem .2rem;
            }

            .modal-button-wrapper {
              .AppButton {
                margin-bottom: .1rem;
              }
            }
          }
        }
      }
    }
  }
</style>
